var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2743 15.1392C12.2743 14.122 11.4307 13.2784 10.4135 13.2784C9.39629 13.2784 8.55273 14.122 8.55273 15.1392C8.55273 16.1565 9.39629 17 10.4135 17C11.4307 17 12.2743 16.1565 12.2743 15.1392Z",
    fill: "#AEAEAE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2265 10.3012C12.5718 7.64644 8.22992 7.64644 5.5752 10.3012L7.33674 12.0627C9.02385 10.3756 11.7778 10.3756 13.4897 12.0627L15.2265 10.3012Z",
    fill: "#AEAEAE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3029 7.22478C16.194 5.11589 13.3904 3.97461 10.4132 3.97461C7.43591 3.97461 4.63233 5.1407 2.52344 7.24959L4.28498 9.01114C7.6592 5.63691 13.1919 5.63691 16.5662 9.01114L18.3029 7.22478Z",
    fill: "#AEAEAE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3793 6L21 4.37094C15.2022 -1.45698 5.79783 -1.45698 0 4.37094L1.62065 6C6.52826 1.06692 14.4717 1.06692 19.3793 6Z",
    fill: "#AEAEAE"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiIcon);
export default __webpack_public_path__ + "static/media/wifiIcon.520d7e596a18e4ad5cfafb1c69490bc0.svg";
export { ForwardRef as ReactComponent };